
angular.module('bmsApp.crm', [
	'bmsApp.crm.enquiry',
	'bmsApp.crm.customer',
	'bmsApp.crm.prospect',
	'bmsApp.crm.document',
	'bmsApp.crm.email',
	'bmsApp.crm.salespipeline',
	'bmsApp.merrymaids',
	'bmsApp.trugreen',
	'ui.router',
	'uiGmapgoogle-maps'
])
	.config([
		'$stateProvider', 'uiGmapGoogleMapApiProvider', function config(
			$stateProvider,
			uiGmapGoogleMapApiProvider) {

			$stateProvider

				.state('main.crm', {
					abstract: true,
					url: '/crm',
					views: {
						'main@main': {
							templateUrl: 'ng/crm/crmMain.html',
							controller: 'CrmMainCtrl'
						}
					}
				})

				;

		}]);
